import { inject, onMounted, onUnmounted, getCurrentInstance } from 'vue';
import type { CableVueContext } from '@/types/cableContext';

type CableChannel = 'ContactMessagesChannel' | 'ContactMessagesInboxChannel' | 'ContactMessagesUnreadChannel';

type UseCableChannelOptions<T> = {
  channel: CableChannel;
  // eslint-disable-next-line no-unused-vars
  onMessage?: (data: T) => void;
  onConnected?: () => void;
};

export const useCableChannel = <T = unknown>({ channel, onMessage, onConnected }: UseCableChannelOptions<T>) => {
  const cable = inject<CableVueContext>('cable');
  const instance = getCurrentInstance()!;

  const channels = {
    [channel]: {
      connected: onConnected,
      received: onMessage,
    },
  };

  const perform = (action: 'send_message', data: Record<string, unknown>) => {
    cable?.perform({ channel, action, data } as Parameters<CableVueContext['perform']>[0]);
  };

  onMounted(() => {
    cable?.registerChannels(channels, instance.proxy);
    cable?.subscribe({ channel });
  });

  onUnmounted(() => {
    cable?.unregisterChannels(channels, instance.proxy);
    cable?.unsubscribe(channel);
  });

  return { perform };
};
